import React, { useEffect } from 'react';
import { Redirect, useHistory, useLocation } from 'react-router-dom';
import { useAuth } from '~/hooks';
import { ROUTER_PATHS } from '~/constants';

interface Login2faGuardProps {
  component: JSX.Element;
}

const Login2faGuard: React.FC<Login2faGuardProps> = ({ component }) => {
  const { isAuthenticated, isCode2FAPending } = useAuth();

  return isAuthenticated() && !isCode2FAPending() ? (
    <Redirect to={ROUTER_PATHS.PORTAL.HOME} />
  ) : !isAuthenticated() && !isCode2FAPending() ? (
    <Redirect to={ROUTER_PATHS.LOGIN} />
  ) : (
    <>{component}</>
  );
};

export default Login2faGuard;
